export default __webpack_public_path__ + "static/media/GoogleImg.4beb0761.png";